import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Play,
  ArrowRight,
  Calendar,
} from "lucide-react";

// All YouTube video testimonials
const youtubeVideos = [
  { id: "AckVuB84FNo", title: "Témoignage Alexandre" },
  { id: "TonsXr2vJXQ", title: "Témoignage Johan" },
  { id: "9lr8qqIot8Q", title: "Témoignage Jules" },
  { id: "9kb5Kxi9MwA", title: "Témoignage Maryse" },
  { id: "KLBxBaoVtnk", title: "Témoignage Mohammed" },
  { id: "t81IfgAyh54", title: "Témoignage Babacar" },
  { id: "DN3A2jvGlx8", title: "Témoignage Guillaume" },
  { id: "cly5yg48CoE", title: "Témoignage Mathis" },
];

export default function FeedbacksPage() {
  return (
    <div className="overflow-hidden" data-testid="feedbacks-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 bg-white" data-testid="feedbacks-hero">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-[#52fbb0]/10 text-slate-700 px-4 py-2 rounded-full text-sm font-medium mb-6 animate-fade-in">
              <Play className="h-4 w-4" />
              Témoignages vidéo
            </div>
            <h1 className="font-manrope font-bold text-4xl md:text-5xl lg:text-6xl text-slate-900 mb-6 animate-fade-in-up">
              Nos freelances{" "}
              <span className="gradient-text">témoignent</span>
            </h1>
            <p className="text-slate-600 text-lg md:text-xl leading-relaxed animate-fade-in-up delay-200">
              Découvrez en vidéo les retours d'expérience de nos freelances accompagnés par Freelanceurs.io.
            </p>
          </div>
        </div>
      </section>

      {/* Videos Grid Section */}
      <section className="py-20 md:py-32 bg-slate-50" data-testid="videos-grid">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
            {youtubeVideos.map((video, index) => (
              <div
                key={video.id}
                className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
                data-testid={`video-card-${index}`}
              >
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="w-full h-full"
                  />
                </div>
                <div className="p-4 border-t border-slate-100">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-[#52fbb0]/10 rounded-full flex items-center justify-center">
                      <Play className="h-4 w-4 text-[#52fbb0]" />
                    </div>
                    <span className="text-slate-700 font-medium">{video.title}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-32 bg-slate-900" data-testid="feedbacks-cta">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-manrope font-bold text-3xl md:text-4xl lg:text-5xl text-white mb-6">
              Prêt à rejoindre nos freelances ?
            </h2>
            <p className="text-slate-300 text-lg md:text-xl mb-10">
              Comme eux, gagnez plus et payez moins avec l'accompagnement FREELANCEURS.io.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/rendez-vous"
                data-testid="feedbacks-rdv-cta"
              >
                <Button className="bg-[#52fbb0] text-slate-900 hover:bg-[#34d399] font-bold rounded-full px-10 py-6 text-lg">
                  <Calendar className="mr-2 h-5 w-5" />
                  Prendre rendez-vous
                </Button>
              </Link>
              <Link to="/simulateur" data-testid="feedbacks-simulateur-cta">
                <Button variant="outline" className="border-2 border-white/20 text-white hover:bg-white/10 font-semibold rounded-full px-10 py-6 text-lg">
                  Essayer le simulateur
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
